import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useShopCatalog } from "../marketplace/useShopCatalog";
import { TODAY_PRINTS_PATH, todayPrintsPath } from "../prints/paths";
import { PrintTile } from "../prints/today/PrintTile";
import { MyPreorders } from "../prints/today/MyPreorders";
import { GatheredCards } from "../prints/today/GatheredCards";
import { PromiseDialogHost } from "../prints/promise/PromiseDialog";
import { FORMATS_BIG_FIRST, ORIGINAL_FORMATS, useToday } from "../prints/today/useToday";
import "../marketplace/storefront/storefront.css";
import "../prints/today/todayPrints.css";

// /collectibles: AOTD prints. Only today's (the latest) day is on offer, as small tiles that
// open today's prints on that format; the original is on show to everyone. The member's
// pre-orders for any day, and their gathered trading cards, are listed under it. Public.

const CollectiblesPage: React.FC = () => {
  const { data: day, error, refetch } = useToday();
  const { products } = useShopCatalog();

  useEffect(() => {
    document.title = "NΛSOS Collectibles";
  }, []);

  return (
    <div className="sf-page tp-page">
      <header className="sf-head">
        <div>
          <div className="sf-title-row">
            <h1 className="sf-title">collectibles</h1>
            <Link to="/marketplace" className="sf-head-chip">
              ← store
            </Link>
          </div>
          <p className="sf-sub">prints of the art of the day, numbered when printed</p>
        </div>
      </header>

      {day ? (
        <section className="cl2-section" aria-labelledby="cl2-today">
          <div className="cl2-section-head">
            <h2 id="cl2-today" className="tp-h2">
              <Link to={TODAY_PRINTS_PATH}>
                today · #{day.number} {day.title}
              </Link>
            </h2>
            <Link to={TODAY_PRINTS_PATH} className="tp-link">
              all of today&apos;s prints →
            </Link>
          </div>
          <ul className="cl2-grid">
            {FORMATS_BIG_FIRST.map((info, i) => (
              <PrintTile
                key={info.format}
                day={day}
                info={info}
                edition="print"
                products={products}
                to={todayPrintsPath(info.format)}
                index={i}
                tag={info.format === "trading-card" ? "gather" : "pre-order"}
              />
            ))}
            <PrintTile
              day={day}
              info={ORIGINAL_FORMATS[0]}
              edition="original"
              products={products}
              to={`${TODAY_PRINTS_PATH}#tp-og-title`}
              index={FORMATS_BIG_FIRST.length}
              tag={day.isAuthor ? "yours to claim" : "on show"}
            />
          </ul>
        </section>
      ) : error ? (
        <div className="sf-state">
          <p>couldn&apos;t load the prints. try again in a bit.</p>
          <button type="button" className="sf-link-btn" onClick={() => refetch()}>
            try again
          </button>
        </div>
      ) : (
        <p className="sf-state">loading</p>
      )}

      <MyPreorders />
      <GatheredCards />
      <PromiseDialogHost />
    </div>
  );
};

export default CollectiblesPage;
